define(['app'], function (app) {
  return app.Marionette.ItemView.extend({
    template: false,

    events: {
      click: 'show'
    },

    show: function (e) {
      e.preventDefault()

      var el = app.$(e.currentTarget)
      var modal = el.data('modal')

      app.events.commands.execute('modal:' + modal + ':show')

      return false
    }
  })
})
